export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isFunction.js
// module id = 203
// module chunks = 1